import React from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import { Link } from "react-router-dom";
import "./IntakeFormPagesCommon.css";

const IntakeFormPage18: React.FC = () => {
  return (
    <PageWrapper>
      <div className="signup-page-container">
        <div className="signup-content">
          <p
            className="intake-form-content-heading"
            style={{ marginBottom: "20px" }}
          >
            Amazing! your online process for GLP-1 is complete. 
          </p>
          <p className="intake-form-content-heading intake-sub-header" style={{ marginBottom: "40px" }}>
          Please check your inbox for the next steps. In case of any further queries, please reach out to us on <span style={{ color: "#0C3972"}}>membersupport@claya.com</span>
          </p>

          <Link to="https://claya.com/">
            <button className="next-btn sticky-btn">
              Explore claya membership
            </button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage18;
